import * as React from 'react'

import { Box, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'

import { useNineGridBox } from 'modules/competencies/lib/ninegridboxContext'
import ninegridboxes from 'modules/competencies/store/collections/ninegridboxes'
import type ConditionForm from 'modules/reports/lib/Store/FormCollections/Filter/Condition/ConditionForm'
import type FieldModel from 'modules/reports/store/models/Field'

export interface FieldType {
  field?: FieldModel
  form: ConditionForm
}
interface Props {
  competencyId: number
  isXaxis: boolean
}

const Field = ({ competencyId, isXaxis }: Props) => {
  const { onSelectCompetency, form } = useNineGridBox()
  const ninegridbox = ninegridboxes.getCompetency(competencyId)

  React.useEffect(() => {
    if (ninegridbox) return

    const field = form.get(isXaxis ? 'x_axis_ids' : 'y_axis_ids')
    const newCompetencyIds = field.value.filter((val: number) => val !== competencyId)
    field.set(newCompetencyIds)
  }, [competencyId, ninegridbox, form, isXaxis])

  if (!ninegridbox) return null

  return (
    <Box
      borderRadius={{
        all: 'abs008',
      }}
      background="grey200"
    >
      <Box padding="s8" flexDirection="row" alignItems="center" justifyContent="spaceBetween">
        <Box gap="s4" flexDirection="row" alignItems="center">
          <Touchable onClick={() => onSelectCompetency(competencyId, isXaxis)}>
            <Icon.Small icon="close" color="radicalRed1000" />
          </Touchable>
          <Text.Normal weight="medium" size="200" color="grey1000">
            {ninegridbox.competencyName}
          </Text.Normal>
        </Box>
        {ninegridbox.competencyDescription.length > 0 && (
          <Box flexDirection="row" alignItems="center" gap="s4">
            <InformationTooltip
              information={ninegridbox.competencyDescription}
              color="grey000White"
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default observer(Field)
